import { IConfig } from "lib/ShiOneClient";
import { GetBearerToken } from "./BearerToken";
import { shouldIgnoreImpersonation } from "./impersonationOverride";

const isInternalPath = () => window.location.pathname.startsWith("/internal/");

export const getImpersonateHeaders = () => {
  if (shouldIgnoreImpersonation() || isInternalPath()) {
    return {
      impersonateUserId: null,
      assumeIdentity: null,
      impersonateAccount: null,
      demoData: null,
      impersonateEmail: null,
    };
  }

  const impersonateUserString = localStorage.getItem("impersonateUser");
  let impersonateUserId = null;
  let assumeIdentity = null;
  let impersonateEmail = null;

  if (impersonateUserString) {
    try {
      const parsed = JSON.parse(impersonateUserString);
      impersonateUserId = parsed.userId || null;
      assumeIdentity = parsed.assumeIdentity === true || parsed.assumeIdentity === "true"
        ? "true"
        : null;
      impersonateEmail = parsed.email || null;
    } catch {
      // A non-JSON value is a stale pre-migration entry; ignore it.
    }
  }

  return {
    impersonateUserId,
    assumeIdentity,
    impersonateAccount: localStorage.getItem("impersonateAccount"),
    demoData: localStorage.getItem("demoData"),
    impersonateEmail,
  };
};

const getAdditionalHeaders = () => {
  const { impersonateUserId, assumeIdentity, impersonateAccount, demoData, impersonateEmail } = getImpersonateHeaders();
  const additionalHeaders: HeadersInit = new Headers();

  if (impersonateUserId) {
    additionalHeaders.set("ImpersonateUserId", impersonateUserId);
  }

  if (assumeIdentity) {
    additionalHeaders.set("AssumeIdentity", assumeIdentity);
  }

  if (impersonateAccount) {
    additionalHeaders.set("ImpersonateAccount", impersonateAccount);
  }

  if (demoData) {
    additionalHeaders.set("DemoData", demoData);
  }

  if (impersonateEmail) {
    additionalHeaders.set("ImpersonateEmail", impersonateEmail);
  }

  return additionalHeaders;
};

const getBearerToken = async () => {
  const token = await GetBearerToken();
  return `Bearer ${token}`;
};

export const ApiClientConfig: IConfig = {
  getAuthorization: getBearerToken,
  getAdditionalHeaders: getAdditionalHeaders,
};